export const checkAcessRights = (route: string, rightID: string) => {
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    menu_id: number;
    menu_key: string;
    menu_name: string;
    rights_id: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }
  // userResponse
  //   ?.find((e: any) => e.MenuKey === route?.substring(1))
  //   ?.RightsID?.includes(rightID);
  // return true;
  return userResponse
    ?.find((e: any) => e.menu_key === route?.substring(1))
    ?.rights_id?.includes(rightID);
};

export const hasRights = (menuKey: string) => {
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  const menu = userResponse.find((item) => item.MenuKey === menuKey);
  return menu && menu.RightsID;
};

export function formatToIndianCurrency(amount: number): string {
  const options: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
  return amount?.toLocaleString("en-IN", options);
}

export function formatToIndianCurrencyWithoutSymbol(amount: number): string {
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true, // This enables Indian numbering system grouping (commas)
  };
  return amount?.toLocaleString("en-IN", options);
}

export function formatWeight(
  weight: number | string | null | undefined
): string {
  if (weight === null || weight === undefined) {
    return "0.000";
  }

  const numericWeight =
    typeof weight === "string" ? parseFloat(weight) : weight;

  if (isNaN(numericWeight)) {
    return "0.000";
  }

  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
    useGrouping: true, // Adds comma separators for thousands
  };

  return numericWeight.toLocaleString("en-IN", options);
}

export function hasRequired(errors: any, fieldKeys: string[]) {
  const hasAnyFieldWithValue = fieldKeys.some((fieldKey) =>
    Object.keys(errors).some(
      (key) => key.startsWith(fieldKey) && errors[key] !== ""
    )
  );
  return !hasAnyFieldWithValue;
}
